// 在最开始就重写console.warn，确保能捕获所有警告
const originalConsoleWarn = console.warn
console.warn = function(...args) {
  const msg = args[0] || ''
  if (
    typeof msg === 'string' && 
    (msg.includes('autoFormCreate') || msg.includes('fieldDecoratorId'))
  ) {
    return
  }
  originalConsoleWarn.apply(console, args)
}

import Vue from 'vue'
import Febs from './FEBS'
import router from './router'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import testResquest from './utils/testRequest'
import db from 'utils/localstorage'
import VueApexCharts from 'vue-apexcharts'
// import VueDragResize from 'vue-drag-resize'
import 'vue-easytable/libs/themes-base/index.css'
import { VTable, VPagination } from 'vue-easytable'
import 'ant-design-vue/dist/antd.css'
import 'utils/install'
import '../static/iconfont/iconfont.css'
import 'babel-polyfill'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(iView)
Vue.use(db)
Vue.use(VueApexCharts)
Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
// Vue.component('vue-drag-resize', VueDragResize)
Vue.component('apexchart', VueApexCharts)

Vue.use({
  install(Vue) {
    Vue.prototype.$db = db
  }
})
Vue.prototype.$downloadpdf = testResquest.download
Vue.prototype.$test = testResquest.test
Vue.prototype.$post = request.post
Vue.prototype.$postJson = request.postJson
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$submit = request.submit
Vue.prototype.$putEdit = request.putEdit

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(Febs)
}).$mount('#febs')



// WEBPACK FOOTER //
// ./src/main.js